import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4ed7bee4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-4ed7bee4><div class=\"formation-card\" data-v-4ed7bee4><div class=\"formation-icon-wrapper\" data-v-4ed7bee4><i class=\"flaticon-education formation-icon\" data-v-4ed7bee4></i></div><div class=\"formation-content\" data-v-4ed7bee4><h5 class=\"formation-title\" data-v-4ed7bee4>Amis des Séminaires</h5><div class=\"formation-niveau\" data-v-4ed7bee4><i class=\"flaticon-level\" data-v-4ed7bee4></i><span data-v-4ed7bee4>Sa vision est de contribuer (par un soutien spirituel, moral et financier) à l’amélioration des conditions de formation des futurs prêtres et d’œuvrer pour l’avènement de la prise en charge complète et autonome de cette formation par l’Église du Bénin. En suscitant beaucoup de bonnes volontés acquises à cette noble cause, ils ont pour ambition d’imiter les modèles de la Bienheureuse Pauline JARICOT et de Mme DOMPAGO (béninoise ayant vécu à Ouidah, elle a passé toute sa vie à aider le grand séminaire St Gall, en priant et se donnant corps et âme pour collecter tout ce qui peut servir à la bonne marche de la formation des futurs prêtres). </span></div></div></div></div><br data-v-4ed7bee4><br data-v-4ed7bee4><br data-v-4ed7bee4>", 4)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "blog-card style1" }
const _hoisted_9 = {
  class: "blog-info",
  style: {"min-height":"250px"}
}
const _hoisted_10 = { class: "blog-metainfo list-style" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.truncatedArticles, (article, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-6 col-md-6",
            key: index
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "blog-img",
                style: _normalizeStyle({height:'277px', backgroundImage: `url(${_ctx.getUrlApiForFiles(article.urlImage)})`, backgroundSize: 'cover',backgroundPosition: 'center'})
              }, null, 4),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", null, [
                    _hoisted_11,
                    _createTextVNode(),
                    _createVNode(_component_router_link, { to: "#" }, {
                      default: _withCtx(() => [
                        _createTextVNode("L' École d’Initiation Théologique et Pastorale")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_12,
                    _createTextVNode(_toDisplayString(_ctx.format_Date(article.datePublication)), 1)
                  ])
                ]),
                _createElementVNode("h3", null, [
                  _createVNode(_component_router_link, {
                    to: { name: 'ViewArticlePage', params: { id: article.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(article.titre), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createVNode(_component_router_link, {
                  to: { name: 'ViewArticlePage', params: { id: article.id } },
                  class: "link style1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Lire plus "),
                    _hoisted_13
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}